export enum AnalysisEvent {
  UPDATE_ANALYSIS = "updateAnalysis",
  RUN_ANALYSIS_TASK = "runAnalysisTask",
  FINISHED_ANALYSIS_TASK = "finishedAnalysisTask",
  START_FH2_FILE_IMPORT = "startFh2FileImport",
  /** A data checks run started (task ID as argument), e.g. by the coverage. */
  START_DATA_CHECK = "startDataCheck",
  QFLY_SERVER_STATE_CHANGED = "qflyServerStateChanged",
}